import React from 'react';
import { View, Text } from 'react-native';
import Terms from '../../components/Terms'
import { styles } from './styles';
import HeaderDefault from '../../components/HeaderDefault'
import { FormattedMessage } from 'react-intl';

const TermsService = () => (
  <View style={{ flex: 1 }}>
    <HeaderDefault title={<FormattedMessage id='termsService.termosUso'/>} />
    <Terms />
  </View>
)
export default TermsService